import React, { ReactElement, MouseEvent } from 'react';
import { useState } from 'react';

import { BASE_DOCUMENT_API_HOST } from '../../../utils/api-util';
import { getClassNames, noOp } from '../../../utils/util';

import './image.scss';

type Props = {
  src: string | File;
  className?: string;
  alt?: string;
  onClick?: (event: MouseEvent<HTMLImageElement>) => void;
  testId?: string;
};

const getSrc = (src: string | File): string => {
  if (typeof src === 'string') {
    return `${BASE_DOCUMENT_API_HOST}/rest/service/document/retrieve/octet-stream?ref=${src}`;
  }

  return URL.createObjectURL(src);
};

const Image = ({ src, className = '', alt, onClick = noOp, testId }: Props): ReactElement => {
  const [loading, setLoading] = useState<boolean>(true);

  return (
    <img
      className={`${getClassNames('image', { loading })} ${getClassNames(className, { loading })}`}
      src={getSrc(src)}
      alt={alt}
      onLoad={(): void => setLoading(false)}
      onClick={onClick}
      data-testid={testId}
    />
  );
};

export default Image;
